import { render, staticRenderFns } from "./LegalPage.vue?vue&type=template&id=797b070b&scoped=true&"
import script from "./LegalPage.vue?vue&type=script&lang=js&"
export * from "./LegalPage.vue?vue&type=script&lang=js&"
import style0 from "./LegalPage.vue?vue&type=style&index=0&id=797b070b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b070b",
  null
  
)

export default component.exports